/*
|--------------------------------------------------------------------------
| Custom Javascript code
|--------------------------------------------------------------------------
|
| Now that you configured your website, you can write additional Javascript
| code inside the following function. You might want to add more plugins and
| initialize them in this file.
|
*/
// console.clear();
// ("use strict");

$(window).on("load", function () {
  var conbg = $(".content-background");
  var conbgtop = 0;
  if (conbg.length) {
    conbgtop = conbg.offset().top;
  }
  $(".footer").css("top", $(".content-background").outerHeight() + conbgtop);
});

$(function () {
  jQuery(document).ready(function ($) {
    (function () {
      var hidden = "hidden";
      var oldtitle = document.title;
      var currenttitle;

      // Standards based on browsers:
      if (hidden in document)
        document.addEventListener("visibilitychange", onchange);
      else if ((hidden = "mozHidden") in document)
        document.addEventListener("mozvisibilitychange", onchange);
      else if ((hidden = "webkitHidden") in document)
        document.addEventListener("webkitvisibilitychange", onchange);
      else if ((hidden = "msHidden") in document)
        document.addEventListener("msvisibilitychange", onchange);
      // IE 9 and lower:
      else if ("onfocusin" in document)
        document.onfocusin = document.onfocusout = onchange;
      // All others:
      else
        window.onpageshow =
          window.onpagehide =
          window.onfocus =
          window.onblur =
            onchange;

      //if tab change happens set status to either hidden or visible
      function onchange(evt) {
        var v = "visible",
          h = "hidden",
          evtMap = {
            //check events and set status based on event type
            focus: v,
            focusin: v,
            pageshow: v,
            blur: h,
            focusout: h,
            pagehide: h,
          };

        evt = evt || window.event;
        if (evt.type in evtMap) {
          // check the title
          currenttitle = oldtitle;
          $(document).attr("title", currenttitle);
        } else {
          // We are in hidden state so create unique title
          currenttitle = this[hidden] ? "Please don't leave me :'(" : oldtitle; //update to whatever you want
          $(document).attr("title", currenttitle);
        }
      }

      // set the initial state (but only if browser supports the Page Visibility API)
      if (document[hidden] !== undefined)
        onchange({ type: document[hidden] ? "blur" : "focus" });
    })();
  });

  var didScroll;
  var lastScrollTop = 0;
  var delta = 5;
  var navbarHeight = $(".mobile-navbar").outerHeight();

  $(window).on("scroll", function () {
    didScroll = true;
  });

  setInterval(function () {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 250);

  function hasScrolled() {
    var st = $(this).scrollTop();

    if (Math.abs(lastScrollTop - st) <= delta) return;

    if (st > lastScrollTop && st > navbarHeight) {
      $(".mobile-navbar").removeClass("nav-down").addClass("nav-up");
    } else {
      if (st + $(window).height() < $(document).height()) {
        $(".mobile-navbar").removeClass("nav-up").addClass("nav-down");
      }
    }

    lastScrollTop = st;
  }

  var wH = $(window).innerHeight(),
    wW = $(window).innerWidth();
  console.log(wH, wW);
  if (wH >= wW) {
    $(".snap-container-mobile").removeClass("d-none");
    $(".snap-container-mobile").addClass("d-block");
  } else {
    $(".snap-container").removeClass("d-none");
    $(".snap-container").addClass("d-block");
  }

  $(".snap-container").scroll(function () {
    var sT = $(".snap-container").scrollTop();
    var wH = $(window).height();
    var hH = $("#curtain1").innerHeight();
    console.log(sT, wH, hH);
    if (sT >= 0 && sT < hH) {
      $("#curtain1").addClass("selected");
    } else {
      $("#curtain1").removeClass("selected");
    }
    if (sT >= hH && sT < 2 * hH) {
      $("#curtain2").addClass("selected");
    } else {
      $("#curtain2").removeClass("selected");
    }
    if (sT >= 2 * hH && sT < 3 * hH) {
      $("#curtain3").addClass("selected");
    } else {
      $("#curtain3").removeClass("selected");
    }
    if (sT >= 3 * hH && sT < 4 * hH) {
      $("#curtain4").addClass("selected");
    } else {
      $("#curtain4").removeClass("selected");
    }
  });

  $(window).on("scroll", function () {
    var scrollHeight = $(document).height();
    var scrollPosition = $(window).height() + $(window).scrollTop();
    var bd = (scrollHeight - scrollPosition) / scrollHeight;
    console.log(bd);
    if ((scrollHeight - scrollPosition) / scrollHeight < 0.1) {
      var sL = $(".snap-container-mobile").scrollLeft();
      var wW = $(window).width();
      var hW = $("#curtain5").innerWidth();
      console.log(sL, wW, hW);
      if (sL >= 0 && sL < 0.9 * hW) {
        $("#curtain5").addClass("selected-mobile");
      } else {
        $("#curtain5").removeClass("selected-mobile");
      }
      if (sL >= 0.9 * hW && sL < 1.9 * hW) {
        $("#curtain6").addClass("selected-mobile");
      } else {
        $("#curtain6").removeClass("selected-mobile");
      }
      if (sL >= 1.9 * hW && sL < 2.9 * hW) {
        $("#curtain7").addClass("selected-mobile");
      } else {
        $("#curtain7").removeClass("selected-mobile");
      }
      if (sL >= 2.9 * hW && sL < 4 * hW) {
        $("#curtain8").addClass("selected-mobile");
      } else {
        $("#curtain8").removeClass("selected-mobile");
      }
      var sT = $(".snap-container").scrollTop();
      var wH = $(window).height();
      var hH = $("#curtain1").innerHeight();
      console.log(sT, wH, hH);
      if (sT >= 0 && sT < hH) {
        $("#curtain1").addClass("selected");
      } else {
        $("#curtain1").removeClass("selected");
      }
    } else {
      $(".selected").removeClass("selected");
      $(".selected-mobile").removeClass("selected-mobile");
    }
  });

  $(".snap-container-mobile").scroll(function () {
    var sL = $(".snap-container-mobile").scrollLeft();
    var wW = $(window).width();
    var hW = $("#curtain5").innerWidth();
    console.log(sL, wW, hW);
    if (sL >= 0 && sL < 0.9 * hW) {
      $("#curtain5").addClass("selected-mobile");
    } else {
      $("#curtain5").removeClass("selected-mobile");
    }
    if (sL >= 0.9 * hW && sL < 1.9 * hW) {
      $("#curtain6").addClass("selected-mobile");
    } else {
      $("#curtain6").removeClass("selected-mobile");
    }
    if (sL >= 1.9 * hW && sL < 2.9 * hW) {
      $("#curtain7").addClass("selected-mobile");
    } else {
      $("#curtain7").removeClass("selected-mobile");
    }
    if (sL >= 2.9 * hW && sL < 4 * hW) {
      $("#curtain8").addClass("selected-mobile");
    } else {
      $("#curtain8").removeClass("selected-mobile");
    }
  });

  var scW = $(".slider-circle").width();
  var dlW = $(".dot-link").width();
  $(".slider-circle").css("height", scW);
  $(".dot-link").css("height", dlW);
  // $(".selected-dot").css("width", dlW);
  var scmH = $(".slider-circle-mobile").height();
  var dcmH = $(".dots-container-mobile").height();
  $(".slider-circle-mobile").css("width", scmH);
  $(".selected-dot-mobile").css("width", dcmH);
  $(".unselected-dot-mobile").css("width", dcmH);

  var cbH = $(".content-bottom").innerHeight();
  var cbW = $(".content-bottom").innerWidth();
  if (cbW > cbH && cbW > 576) {
    $(".lenscorp").css(
      "background-image",
      "url(assets/img/workT/lenscorp.jpg)"
    );
    $(".techboard").css(
      "background-image",
      "url(assets/img/workT/techboard.jpg)"
    );
    $(".udgamdes").css(
      "background-image",
      "url(assets/img/workT/udgamdes.jpg)"
    );
    $(".udgamweb").css(
      "background-image",
      "url(assets/img/workT/udgamweb.jpg)"
    );
    $(".backshore").css(
      "background-image",
      "url(assets/img/workT/backshore.jpg)"
    );
    $(".osmosis").css("background-image", "url(assets/img/workT/osmosis.jpg)");
    $(".logocoll").css(
      "background-image",
      "url(assets/img/workT/logocoll.jpg)"
    );
    $(".aspire").css("background-image", "url(assets/img/workT/aspire.jpg)");
    $(".apparels").css(
      "background-image",
      "url(assets/img/workT/apparels.jpg)"
    );
  }

  $(".content-left").hover(
    function () {
      // $(this).css("width", "70%");
      // $(".content-right").css("width", "30%");
      // $(".work-slider").css("left", "70%");
      $(".work-text-left").animate({ padding: "2%" }, 150);
      $(".work-text-left").css("border-radius", "24px");
      $(".techboard>.work-text-left > .work-type-left")
        .removeClass("text-work-type-dark")
        .addClass("text-work-type-light");
      $(".techboard>.work-text-left > .work-heading-left")
        .removeClass("text-work-title-dark")
        .addClass("text-work-title-light");
      $(".techboard>.work-text-left").css("background-color", "#242424");
      $(".udgamweb>.work-text-left > .work-type-left")
        .addClass("text-work-type-dark")
        .removeClass("text-work-type-light");
      $(".udgamweb>.work-text-left > .work-heading-left")
        .addClass("text-work-title-dark")
        .removeClass("text-work-title-light");
      $(".udgamweb>.work-text-left").css("background-color", "#efeeee");
      $(".osmosis>.work-text-left > .work-type-left")
        .removeClass("text-work-type-dark")
        .addClass("text-work-type-light");
      $(".osmosis>.work-text-left > .work-heading-left")
        .removeClass("text-work-title-dark")
        .addClass("text-work-title-light");
      $(".osmosis>.work-text-left").css("background-color", "#242424");
      $(".aspire>.work-text-left > .work-type-left")
        .addClass("text-work-type-dark")
        .removeClass("text-work-type-light");
      $(".aspire>.work-text-left > .work-heading-left")
        .addClass("text-work-title-dark")
        .removeClass("text-work-title-light");
      $(".aspire>.work-text-left").css("background-color", "#efeeee");
    },
    function () {
      $(this).css("width", "50%");
      $(".content-right").css("width", "50%");
      $(".work-slider").css("left", "50%");
      $(".work-text-left").animate({ padding: "0%" }, 150);
      $(".work-text-left").css("border-radius", "0");
      $(".techboard>.work-text-left > .work-type-left")
        .addClass("text-work-type-dark")
        .removeClass("text-work-type-light");
      $(".techboard>.work-text-left > .work-heading-left")
        .addClass("text-work-title-dark")
        .removeClass("text-work-title-light");
      $(".techboard>.work-text-left").css("background-color", "transparent");
      $(".udgamweb>.work-text-left > .work-type-left")
        .removeClass("text-work-type-dark")
        .addClass("text-work-type-light");
      $(".udgamweb>.work-text-left > .work-heading-left")
        .removeClass("text-work-title-dark")
        .addClass("text-work-title-light");
      $(".udgamweb>.work-text-left").css("background-color", "transparent");
      $(".osmosis>.work-text-left > .work-type-left")
        .addClass("text-work-type-dark")
        .removeClass("text-work-type-light");
      $(".osmosis>.work-text-left > .work-heading-left")
        .addClass("text-work-title-dark")
        .removeClass("text-work-title-light");
      $(".osmosis>.work-text-left").css("background-color", "transparent");
      $(".aspire>.work-text-left > .work-type-left")
        .removeClass("text-work-type-dark")
        .addClass("text-work-type-light");
      $(".aspire>.work-text-left > .work-heading-left")
        .removeClass("text-work-title-dark")
        .addClass("text-work-title-light");
      $(".aspire>.work-text-left").css("background-color", "transparent");
    }
  );
  $(".content-right").hover(
    function () {
      // $(this).css("width", "70%");
      // $(".content-left").css("width", "30%");
      // $(".work-slider").css("left", "30%");
      $(".work-text-right").animate({ padding: "2%" }, 150);
      $(".work-text-right").css("border-radius", "24px");
      $(".udgamdes>.work-text-right > .work-type-right")
        .removeClass("text-work-type-light")
        .addClass("text-work-type-dark");
      $(".udgamdes>.work-text-right > .work-heading-right")
        .removeClass("text-work-title-light")
        .addClass("text-work-title-dark");
      $(".udgamdes>.work-text-right").css("background-color", "#efeeee");
      $(".backshore>.work-text-right > .work-type-right")
        .addClass("text-work-type-light")
        .removeClass("text-work-type-dark");
      $(".backshore>.work-text-right > .work-heading-right")
        .addClass("text-work-title-light")
        .removeClass("text-work-title-dark");
      $(".backshore>.work-text-right").css("background-color", "#242424");
      $(".logocoll>.work-text-right > .work-type-right")
        .removeClass("text-work-type-light")
        .addClass("text-work-type-dark");
      $(".logocoll>.work-text-right > .work-heading-right")
        .removeClass("text-work-title-light")
        .addClass("text-work-title-dark");
      $(".logocoll>.work-text-right").css("background-color", "#efeeee");
      $(".apparels>.work-text-right > .work-type-right")
        .addClass("text-work-type-light")
        .removeClass("text-work-type-dark");
      $(".apparels>.work-text-right > .work-heading-right")
        .addClass("text-work-title-light")
        .removeClass("text-work-title-dark");
      $(".apparels>.work-text-right").css("background-color", "#242424");
    },
    function () {
      $(this).css("width", "50%");
      $(".content-left").css("width", "50%");
      $(".work-slider").css("left", "50%");
      $(".work-text-right").animate({ padding: "0%" }, 150);
      $(".work-text-right").css("border-radius", "0");
      $(".udgamdes>.work-text-right > .work-type-right")
        .addClass("text-work-type-light")
        .removeClass("text-work-type-dark");
      $(".udgamdes>.work-text-right > .work-heading-right")
        .addClass("text-work-title-light")
        .removeClass("text-work-title-dark");
      $(".udgamdes>.work-text-right").css("background-color", "transparent");
      $(".backshore>.work-text-right > .work-type-right")
        .removeClass("text-work-type-light")
        .addClass("text-work-type-dark");
      $(".backshore>.work-text-right > .work-heading-right")
        .removeClass("text-work-title-light")
        .addClass("text-work-title-dark");
      $(".backshore>.work-text-right").css("background-color", "transparent");
      $(".logocoll>.work-text-right > .work-type-right")
        .addClass("text-work-type-light")
        .removeClass("text-work-type-dark");
      $(".logocoll>.work-text-right > .work-heading-right")
        .addClass("text-work-title-light")
        .removeClass("text-work-title-dark");
      $(".logocoll>.work-text-right").css("background-color", "transparent");
      $(".apparels>.work-text-right > .work-type-right")
        .removeClass("text-work-type-light")
        .addClass("text-work-type-dark");
      $(".apparels>.work-text-right > .work-heading-right")
        .removeClass("text-work-title-light")
        .addClass("text-work-title-dark");
      $(".apparels>.work-text-right").css("background-color", "transparent");
    }
  );

  var cbwW = $(".close-btn").outerWidth();
  var riW = $(".rishi-img").outerWidth();
  var orH = $("#offcanvas-right").height();
  var sbH = $(".social-bar").height();
  var dtH = $(".details-text").height();
  $(".close-btn").css("height", cbwW);
  $(".rishi-img").css("height", riW);
  $(".tabs").css("top", 0.04 * orH + riW);
  $(".tabs-window").css("top", 0.06 * orH + riW);
  $(".tabs-window").css("max-height", 0.92 * orH - riW - sbH);
  if ($("body").width() <= 342) {
    $(".tabs-window").css("max-height", 0.84 * orH - riW - sbH);
  }
  $(".main-details").css("left", 1.25 * riW);
  $(".overlay-trigger").click(function () {
    $(".overlay").removeClass("d-none").addClass("d-block");
    $(".overlay").css("opacity", "0.3");
    $(".overlay").css("filter", "blur(20px)");
  });
  $(".close-btn").click(function () {
    $(".overlay").css("filter", "blur(0px)");
    $(".overlay").css("opacity", "0");
    $(".overlay").addClass("d-none").removeClass("d-block");
  });

  var mouseInside;
  var bH = $("body").height();

  $(document).ready(function () {
    $("#offcanvas-right").hover(
      function () {
        mouseInside = true;
      },
      function () {
        mouseInside = false;
      }
    );

    $("body").mouseup(function () {
      if (!mouseInside) {
        $(".overlay").css("filter", "blur(0px)");
        $(".overlay").css("opacity", "0");
        $(".overlay").addClass("d-none").removeClass("d-block");
      }
    });
  });

  var btw = $(".btn-theme").outerWidth();
  var mbw = $(".menu-button").outerWidth();
  $(".navsmall-container").css("width", (btw + mbw) * 1.2);

  $(".about-link").click(function () {
    $("#contact-tab").removeClass("active");
    $("#about-tab").addClass("active");
    $("#contact").removeClass("active").removeClass("show");
    $("#about").addClass("active").addClass("show");
  });

  $(".contact-link").click(function () {
    $("#about-tab").removeClass("active");
    $("#contact-tab").addClass("active");
    $("#about").removeClass("active").removeClass("show");
    $("#contact").addClass("active").addClass("show");
  });

  $(".details-text").css("top", 0.04 * orH + (riW - dtH) / 2);

  var tbW = $(".timeline-block").outerWidth();
  $(".timeline-block").css("height", tbW);
  var tiW = $(".timeline-illustration").outerWidth();
  $(".timeline-illustration").css("height", tiW);
  var smH = $(".social-menu").outerHeight();
  $(".social-footer").css("height", smH);

  var menubtn = $(".menu-button");
  var menubtntop = 0;
  if (menubtn.length) {
    menubtntop = menubtn.offset().top;
  }
  var mbT =
    menubtntop -
    (window.scrollY || window.pageYOffset || document.body.scrollTop);
  $(".back-button").css("top", mbT);
  var bbH = $(".back-button").height();
  var bbC = mbT + bbH / 2;
  var stT = (bbC + bH / 2) / 2;
  $(".sidebar-text").css("top", stT);
  var slW = $(".sidebar-logo").outerWidth();
  $(".sidebar-logo").css("height", slW);
  $(".next-button").css("width", 0.15 * bH);
  $(".prev-button").css("width", 0.15 * bH);
  $(".sidebar-text").css("width", 0.25 * bH);

  $(window).scroll(function () {
    // calculate the percentage the user has scrolled down the page
    var scrollwin = $(window).scrollTop();
    var articleheight = $(".content-body").outerHeight(true);
    var conbod = $(".content-body");
    var conbodtop = 0;
    if (conbod.length) {
      conbodtop = conbod.offset().top;
    }
    if (scrollwin >= conbodtop) {
      // $(".menu-button").addClass("neumorphismLight");
      // $(".btn-theme").addClass("neumorphismLight2");
      // $(".navbar-sun-light").attr("src", "assets/img/sunDark.svg");
      if (scrollwin <= conbodtop + articleheight) {
        $(".reading-bar").css(
          "width",
          ((scrollwin - conbodtop) / articleheight) * 100 + "%"
        );
      } else {
        $(".reading-bar").css("width", "100%");
      }
    } else {
      // $(".navbar-sun-light").attr("src", "assets/img/sunLight.svg");
      // $(".menu-button").removeClass("neumorphismLight");
      // $(".btn-theme").removeClass("neumorphismLight2");
      $(".reading-bar").css("width", "0px");
    }
  });

  var phH = $(".project-header").outerHeight();
  $(".content-body").css("margin-top", -0.15 * phH);

  var lcW = $(".logo-container").outerWidth();
  $(".logo-container").css("height", lcW);
  $(".flat-container").css("height", lcW);

  var didScroll2;
  var lastScrollTop2 = 0;
  var delta2 = 5;
  var worknavbarHeight = $(".mobile-work-navbar-container").height();

  $(window).on("scroll", function () {
    didScroll2 = true;
  });

  setInterval(function () {
    if (didScroll2) {
      hasScrolled2();
      didScroll2 = false;
    }
  }, 250);

  function hasScrolled2() {
    var st2 = $(this).scrollTop();

    if (Math.abs(lastScrollTop2 - st2) <= delta2) return;

    if (st2 > lastScrollTop2 && st2 > worknavbarHeight) {
      $(".mobile-work-navbar-container")
        .removeClass("nav-work-down")
        .addClass("nav-work-up");
    } else {
      if (st2 + $(window).height() < $(document).height()) {
        $(".mobile-work-navbar-container")
          .removeClass("nav-work-up")
          .addClass("nav-work-down");
      }
    }

    lastScrollTop2 = st2;
  }
  // $(function () {
  //   jQuery(document).ready(function ($) {
  //     $(".footer").css(
  //       "top",
  //       $(".content-background").outerHeight() +
  //         $(".content-background").offset().top
  //     );
  //     // $(".footer").css("bottom", "0");
  //   });
  // });

  var bW = $("body").width();
  if (bW > 786) {
    $(window).on("resize", function () {
      if (window.RT) clearTimeout(window.RT);
      window.RT = setTimeout(function () {
        this.location.reload(false); /* false to get page from cache */
      }, 100);
    });
  }
  var ccw = $(".color-container").outerWidth();
  $(".color-container").css("height", ccw);
  var cw = $(".color").outerWidth();
  $(".color").css("height", cw);

  var phHi = $(".project-header").innerHeight();
  var phW = $(".project-header").innerWidth();
  if (phW < phHi) {
    $(".lenscorp").css("background-image", "url(assets/img/work/lenscorp.jpg)");
    $(".techboard").css(
      "background-image",
      "url(assets/img/work/techboard.jpg)"
    );
    $(".udgamdes").css("background-image", "url(assets/img/work/udgamdes.jpg)");
    $(".udgamweb").css("background-image", "url(assets/img/work/udgamweb.jpg)");
    $(".backshore").css(
      "background-image",
      "url(assets/img/work/backshore.jpg)"
    );
    $(".osmosis").css("background-image", "url(assets/img/work/osmosis.jpg)");
    $(".logocoll").css("background-image", "url(assets/img/work/logocoll.jpg)");
    $(".aspire").css("background-image", "url(assets/img/work/aspire.jpg)");
    $(".apparels").css("background-image", "url(assets/img/work/apparels.jpg)");
  }

  var ltW = $(".logo-thumbnail").width();
  var lcH = $(".logo-card").height();
  if (ltW >= lcH) {
    $(".logo-card").css("height", ltW);
  } else {
    $(".logo-thumbnail").css("width", "100%");
    var newltW = $(".logo-thumbnail").width();
    $(".logo-thumbnail").css("height", newltW);
    $(".logo-brief-body").css("width", "100%");
    $(".logo-brief-body").css("padding", "5%");
  }

  var t = localStorage.getItem("theme") || 0;
  themeSwitcher();
  $(".theme-switcher").click(function () {
    if (t == 1) {
      t = 0;
      localStorage.setItem("theme", 0);
    } else {
      t = 1;
      localStorage.setItem("theme", 1);
    }
    themeSwitcher();
  });
  // console.clear();
  console.log(t);
  function themeSwitcher() {
    if (t == 1) {
      $(".navbar-sun-light").attr("src", "assets/img/moonLight.svg");
      $(".work > img").attr("src", "assets/img/workDark.svg");
      $(".dp > img").attr("src", "assets/img/dpDark.svg");
      $(".about > img").attr("src", "assets/img/aboutDark.svg");
      $(".contact > img").attr("src", "assets/img/contactDark.svg");
      $(".close-btn > img").attr("src", "assets/img/closeLight.svg");
      $(".back > div > img").attr("src", "assets/img/backDark.svg");
      $(".prev > div > img").attr("src", "assets/img/prevDark.svg");
      $(".next > div > img").attr("src", "assets/img/nextDark.svg");
      $(".menu > div > img").attr("src", "assets/img/contactDark.svg");
      $(".menu-button > img").attr("src", "assets/img/contact.svg");
      $(".logo-container img").attr("src", "assets/img/logoShortDark.png");
      $(".logo-container [type='image/png']").attr(
        "srcset",
        "assets/img/logoShortDark.png"
      );
      $(".logo-container [type='image/webp']").attr(
        "srcset",
        "assets/img/logoShortDark.webp"
      );
      $(".sidebar-logo img").attr("src", "assets/img/logoShortLight.png");
      $(".sidebar-logo [type='image/jpeg']").attr(
        "srcset",
        "assets/img/logoShortLight.png"
      );
      $(".sidebar-logo [type='image/webp']").attr(
        "srcset",
        "assets/img/logoShortLight.webp"
      );
      $(".logo-dark").attr("src", "assets/img/logoFullLight.png");
      $(".footer-logo").attr("src", "assets/img/logoFullLight.png");
      $(".logo-light").attr("src", "assets/img/logoFullDark.png");
      $("body").addClass("dark").removeClass("light");
      t = 1;
      localStorage.setItem("theme", 1);
      console.log(t);
    } else {
      $(".navbar-sun-light").attr("src", "assets/img/sunDark.svg");
      $(".work > img").attr("src", "assets/img/work.svg");
      $(".dp > img").attr("src", "assets/img/dp.svg");
      $(".about > img").attr("src", "assets/img/about.svg");
      $(".contact > img").attr("src", "assets/img/contact.svg");
      $(".close-btn > img").attr("src", "assets/img/close.svg");
      $("body").removeClass("dark").addClass("light");
      $(".back > div > img").attr("src", "assets/img/backWhite.svg");
      $(".prev > div > img").attr("src", "assets/img/prevWhite.svg");
      $(".next > div > img").attr("src", "assets/img/nextWhite.svg");
      $(".menu > div > img").attr("src", "assets/img/contact.svg");
      $(".menu-button > img").attr("src", "assets/img/contactDark.svg");
      $(".logo-container img").attr("src", "assets/img/logoShortLight.png");
      $(".logo-container [type='image/png']").attr(
        "srcset",
        "assets/img/logoShortLight.png"
      );
      $(".logo-container [type='image/webp']").attr(
        "srcset",
        "assets/img/logoShortLight.webp"
      );
      $(".sidebar-logo img").attr("src", "assets/img/logoShortDark.png");
      $(".sidebar-logo [type='image/png']").attr(
        "srcset",
        "assets/img/logoShortDark.png"
      );
      $(".sidebar-logo [type='image/webp']").attr(
        "srcset",
        "assets/img/logoShortDark.webp"
      );
      $(".logo-dark").attr("src", "assets/img/logoFullDark.png");
      $(".footer-logo").attr("src", "assets/img/logoFullLight.png");
      $(".logo-light").attr("src", "assets/img/logoFullLight.png");
      t = 0;
      localStorage.setItem("theme", 0);
      console.log(t);
    }
  }
  $(window).on("orientationchange", function () {
    location.reload(true);
  });

  $(".dropdown-toggle-custom").on("click", function () {
    $(".dropdown-menu-custom").toggleClass("show");
  });

  $(document).on("click", function (event) {
    var $trigger = $(".dropdown-toggle-custom");
    if ($trigger !== event.target && !$trigger.has(event.target).length) {
      $(".dropdown-menu-custom").removeClass("show");
    }
  });

  $(".dropdown-menu-custom a").on("click", function () {
    $(this).parent().find("a").removeClass("active");
    $(this).addClass("active");
  });
  $(".content-menu .dropdown-menu a").on("click", function () {
    $(this).parent().find("a").removeClass("active");
    $(this).next().addClass("active");
  });

  $(window).on("scroll", function () {
    $(".target").each(function () {
      if ($(window).scrollTop() >= $(this).offset().top - 125) {
        var id = $(this).attr("id");
        $(".content-menu .dropdown-menu a").removeClass("active");
        $('.content-menu .dropdown-menu a[href="#' + id + '"]').addClass(
          "active"
        );
      }
    });
  });

  $(".text-quoted").each(function () {
    $(".moretext").on("click", function () {
      if ($(this).hasClass("less")) {
        $(this).removeClass("less");
        $(this).html("more...");
        $(this).prev().css("display", "none");
      } else {
        $(this).addClass("less");
        $(this).html("less...");
        $(this).prev().css("display", "inline");
      }
    });
  });

  var _originalSize = $(window).width() + $(window).height();
  if (bW < 786) {
    $(window).on("resize", function () {
      if ($(window).width() + $(window).height() != _originalSize) {
        console.log("keyboard show up");
        $(".social-bar-contact").toggle();
      } else {
        console.log("keyboard closed");
        $(".social-bar-contact").toggle();
      }
    });
  }

  var $body = $("html, body"), // Define jQuery collection
    content = $("#main")
      .smoothState({
        // onStart runs as soon as link has been activated
        onStart: {
          // Set the duration of our animation
          duration: 250,

          // Alterations to the page
          render: function () {
            // Quickly toggles a class and restarts css animations
            content.toggleAnimationClass("is-exiting");
            $body.animate({ scrollTop: 0 });
          },
        },
      })
      .data("smoothState"); // makes public methods available
});
